import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import TopBar from './components/TopBar.jsx';
import { AuthProvider } from './lib/auth.jsx';
import StateList from './pages/StateList.jsx';
import CountyList from './pages/CountyList.jsx';
import CountyDetail from './pages/CountyDetail.jsx';
import AuthPage from './pages/AuthPage.jsx';
import SitesPage from './pages/SitesPage.jsx';
import SiteDetail from './pages/SiteDetail.jsx';
import TeamPage from './pages/TeamPage.jsx';
import NotificationsPage from './pages/NotificationsPage.jsx';
import SupplyChainImport from './pages/SupplyChainImport.jsx';
import { ProfilePage, TeamsPage, SettingsPage } from './pages/AccountPages.jsx';

// The map (MapLibre + vector tiles) is the home page but loads as its own chunk.
const MapPage = lazy(() => import('./pages/MapPage.jsx'));

export default function App() {
  return (
    <AuthProvider>
      <TopBar />
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<div className="map-page map-loading">Loading map…</div>}>
              <MapPage />
            </Suspense>
          }
        />
        {/* List view: the state → county → ZIP tables. */}
        <Route path="/list" element={<StateList />} />
        {/* Static paths rank above /:state in React Router v6, so these win. */}
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/register" element={<AuthPage mode="register" />} />
        {/* Logistics merged into the main map: routes panel there. */}
        <Route path="/logistics" element={<Navigate to="/?panel=routes" replace />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/supply-chain/import" element={<SupplyChainImport />} />
        {/* Account menu sections opened as full pages (the menu's Expand links). */}
        <Route path="/account" element={<ProfilePage />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/sites/:siteId" element={<SiteDetail />} />
        <Route path="/teams/:teamId" element={<TeamPage />} />
        <Route path="/:state" element={<CountyList />} />
        <Route path="/:state/:county" element={<CountyDetail />} />
      </Routes>
    </AuthProvider>
  );
}
